import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';

import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {DialogModule} from 'primeng/dialog';
import {MessageService} from 'primeng/api';
import {Toast} from 'primeng/toast';
import {Router} from '@angular/router';
import {LoginExternoService} from '@core/services/login-externo.service';
import {IconEnviarToken} from '@components/icons/icon-enviar-token/icon-enviar-token.component';

@Component({
  selector: 'app-email-send-token',
  standalone: true,
  imports: [
    FormsModule,
    ButtonModule,
    CardModule,
    DialogModule,
    Toast,
    NgOptimizedImage,
    ReactiveFormsModule,
    IconEnviarToken,
    IconEnviarToken
],
  providers: [MessageService],
  templateUrl: './email-send-token.component.html',
  styleUrl: './email-send-token.component.css'
})
export class EmailSendTokenComponent implements OnInit {
  loading: boolean = false;
  emailCtrl: FormControl = new FormControl('', [Validators.required, Validators.email]);
  @Output() emailSubmitted = new EventEmitter<string>();

  constructor(
    private readonly usuarioExternoService: LoginExternoService,
    private readonly messageService: MessageService,
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    const storedEmail = sessionStorage.getItem('concessionariasEmail');
    if (storedEmail) {
      this.emailCtrl.setValue(storedEmail);
    }
  }

  sendEmailForToken() {
    if (this.emailCtrl.invalid) {
      if (this.emailCtrl.hasError('required')) {
        this.messageService.add({
          severity: 'warn',
          summary: 'E-mail inválido',
          detail: 'Por favor, digite seu e-mail para enviar o token.',
        })
        return;
      }
      if (this.emailCtrl.hasError('email')) {
        this.messageService.add({
          severity: 'warn',
          summary: 'E-mail inválido',
          detail: 'Formato do e-mail inválido. Por favor, digite um e-mail válido para enviar o token.',
        })
      }
      return;
    }

    this.loading = true;

    const email = this.emailCtrl.value;

    this.usuarioExternoService.requestToken(email).subscribe({
      next: () => {
        sessionStorage.setItem('concessionariasEmail', email);
        sessionStorage.setItem('concessionariasEmailSent', 'true');

        this.messageService.add({
          severity: 'success',
          summary: 'Token enviado',
          detail: `Um novo token foi enviado para o seu e-mail: ${email}`
        })
        this.emailSubmitted.emit(email);
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        if (error.status === 404) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Usuário não encontrado',
            detail: 'O e-mail informado não corresponde a nenhum usuário do sistema. Tente novamente ou entre em contato com o suporte.'
          });
          return;
        }
        if (error.status === 403) {
          this.router.navigate(['/access-denied']).then();
          return;
        }
        this.messageService.add({
          severity: 'error',
          summary: 'Falha ao enviar token',
          detail: 'Ocorreu um erro ao solicitar o token. Por favor, tente novamente mais tarde.'
        });
      },
      complete: () => this.loading = false
    });
  }

}
